import axios from 'axios';
import { gsap } from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import { ScrollToPlugin } from 'gsap/ScrollToPlugin';

gsap.registerPlugin(ScrollTrigger, ScrollToPlugin);

const contactBtns = document.querySelectorAll('.contact-modal-btn');
const contactModal = document.querySelector('.contactModal');
const form = document.querySelector('.contactModal .sign-up__form');
const thankYouMessage = document.querySelector('.contactModal .thank-you');

/* open contact form by URL */
if (window.location.href.indexOf("#contact") > -1) {
  contactModal.classList.add('open-modal');
  document.querySelector('body').style.overflow = 'hidden';
}

/* show/hide fields based on Country selection */
const selectCountry = document.querySelector('.contactModal #country');

selectCountry.addEventListener('change', () => {
  
  const selectedCountryFields = document.querySelectorAll('.form-item--' + selectCountry.value);
  const allFields = document.querySelectorAll('.form-item--US, .form-item--CA');

  allFields.forEach((field) => {
    field.style.display = 'none';
    field.querySelector('select,input').toggleAttribute('required');
  });

  selectedCountryFields.forEach((field) => {
    field.style.display = 'block';
  });

});

/* open modal */
contactBtns.forEach((contactBtn) => {
  contactBtn.addEventListener('click', (e) => {
    e.preventDefault();

    contactModal.classList.add('open-modal');
    document.querySelector('body').style.overflow = 'hidden';

  });
});

/* close modal */
const modalClose = document.querySelector('.contactModal--close');

modalClose.addEventListener('click', () => {
  console.log('close');

  // put form back up after submission - not working yet
  contactModal.classList.remove('open-modal');
  document.querySelector('body').style.overflow = 'hidden visible';
});

/**
 * Convert raw form data into an object for AJAX request.
 *
 * @param {Element} form The form element
 * @returns {} Key-value pair of form elements and values
 */
const processFormElements = (form) => {
  const formElements = Array.from(form.elements).filter((element) => element.type !== 'submit');
  const processedFormElements = {};

  formElements.forEach((element) => {
    if (element.value.length > 0) {
      if (element.id) {
        let id = element.id;
        if (id === 'GDPR') {
          if (element.dataset.state == 'checked' || element.value == 'on') {
            processedFormElements[element.id] = 'True';
          } else {
            processedFormElements[element.id] = 'False';
          }
        } else {
          processedFormElements[element.id] = element.value;
        }
      }
    }
  });

  return processedFormElements;
};

/* form submit */
gsap.set(thankYouMessage, {
  autoAlpha: 0,
  display: 'none',
});

form.addEventListener('submit', (e) => {
  e.preventDefault();

  let honeyPotField = document.getElementById("middleName");

  if (honeyPotField.value.length > 0) {
    console.log('get outta here bot');
    // honeypot failed
    return;
  }
  
  //const action = form.getAttribute('action');
  const action = "http://go.jlg.com/l/471491/2022-10-17/29z6p5";

  grecaptcha.ready(function () {
    grecaptcha
      .execute('6Ld22JoqAAAAAAPzVrEbJoyDiUw3Er8cjitq4IWi', { action: 'submit' })
      .then(function (token) {

        let recaptchaResponse = document.getElementById("recaptchaResponse");
        recaptchaResponse.value = token;

        const formData = processFormElements(form);
        let formDataField = document.getElementById("formData");
        formDataField.value = formData;

        console.log(formData);
        // Add your logic to submit to your backend server here.
        axios({
          method: 'post',
          url: '/proxy.php',
          data: {
            action,
            ...formData,
          },
        })
        .then((response) => {
          console.log(response);
          gsap.timeline()
            .to(form, {
              autoAlpha: 0,
              height: 0,
              display: 'none',
              duration: 0.3,
            })
            .to(thankYouMessage, {
              autoAlpha: 1,
              display: 'block',
              duration: 0.3,
            });
          })
          .catch((error) => {
            console.log('error: ' + error);
            const recaptchaError = document.querySelector('#recaptchaFailError');
            recaptchaError.style.display = 'block';
          });
        });
  });
  //grecaptcha.reset();// to reset their widget for any other tries

});